import 'magnific-popup';

const $win = $(window);
const $doc = $(document);

$('.js-video-popup').magnificPopup({
  type: 'iframe'
});